import { staticLeadTableColumns } from '../../../../components/Leads/DynamicFormFields/helper.ts';

const LEAD_ID_FIELD = {
  key_name: 'lead_id',
  alias_name: '',
  key_type: 'STRING',
  is_required: true,
  is_primary: true,
  key_options: [],
};

const cloneValue = (value) => {
  if (Array.isArray(value)) return value.map(cloneValue);
  if (value && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, cloneValue(item)]));
  }
  return value;
};

/** Cloned static columns from legacy helper — never mutates imported definitions. */
export function getStaticFormFields() {
  const staticColumns = Object.values(staticLeadTableColumns).map(cloneValue);
  return [cloneValue(LEAD_ID_FIELD), ...staticColumns];
}

export { LEAD_ID_FIELD };
